import {
  UpdateCompanySettingsMutation,
  UpdateCompanySettingsMutationVariables
} from './__generated__/UpdateCompanySettingsMutation'
import { ApolloClient, gql } from '@apollo/client'

const mutation = gql`
  mutation UpdateCompanySettingsMutation($input: UpdateCompanySettingsInput!) {
    updateCompanySettings(input: $input) {
      features
    }
  }
`

export function updateCompanySettingsMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      UpdateCompanySettingsMutation,
      UpdateCompanySettingsMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate<
    UpdateCompanySettingsMutation,
    UpdateCompanySettingsMutationVariables
  >({
    mutation,
    ...options
  })
}
